import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconArrowBack = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z" }, void 0) }, void 0));
const Memo = memo(SvgIconArrowBack);
export default Memo;
//# sourceMappingURL=IconArrowBack.js.map